<template>
  <el-col v-if="horizontal" :span="spanSetting">
    <el-select :value="value" @change="$emit('change', $event)" :size="size" :placeholder="placeholder">
      <slot></slot>
    </el-select>
  </el-col>
  <el-row v-else>
    <el-col :span="spanTitle">
      <div class="input-title">
        <required-tag v-if="required"></required-tag>
        {{ label }}
      </div>
    </el-col>
    <el-col :span="spanSetting">
      <el-select :value="value" @change="$emit('change', $event)" :size="size" :placeholder="placeholder">
        <slot></slot>
      </el-select>
    </el-col>
  </el-row>
</template>

<script>
import RequiredTag from '@/components/RequiredTag.vue'
import Constants from './Constants'

export default {
  name: 'Selector',
  components: {
    requiredTag: RequiredTag
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number]
    },
    label: {
      type: String
    },
    spanTitle: {
      type: Number,
      default: Constants.SPAN_TITLE
    },
    spanSetting: {
      type: Number,
      default: Constants.SPAN_INPUT
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '選択してください'
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 10px;
  margin-right: 10px;
}
.el-select {
  width: 100%;
}
</style>
